import React from 'react';
import { I18n, Trans } from 'react-i18next';
  
export class Copyright extends React.Component {
  render() {
    return (
     <I18n ns="translations">
        {
          (t, { i18n }) => (
              <div className="row padded-sections">
                <div className="col-md-offset-4 col-md-4 col-sm-4 col-xs-12">
                  <ul id="footer-condn-link">
                    <li><a href="#">{t('footercopyright')}</a> </li>
                    <li><a href="#">{t('footercopyright1')}</a> </li>
                    <li><a href="#">{t('footercopyright2')}</a> </li>
                  </ul>
                  <p className="btm-link"><a href="#">© 2018</a></p>
                </div>          
              </div>
            )
          }
      </I18n>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer/Copyright/Copyright.js